import React from "react";
import clsx from "clsx";
import { Box, Divider, Typography, Grid } from "@mui/material";
import { playerListStyles } from "../styles";

const DummyRound = ({
  rounds,
  divider2Padding = 0.1,
  divider2Style,
  divider2Height,
  divider3Style,
}) => {
  const classes = playerListStyles();

  return (
    <Grid
      item
      xs={3}
      xl={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        minWidth: "230px",
      }}
    >
      {[...Array(Number(rounds))].map((item, index) => {
        return (
          <Box className={classes.box}>
            <Box className={classes.blackNumBox}>{index + 1}</Box>
            <Box className={clsx(classes.mainBox, classes.greyBox)}>
              <Typography variant="body2" className={classes.playerName}>
                TBA
              </Typography>
            </Box>
            {rounds != 1 && (
              <>
                <Divider
                  sx={{
                    bgcolor: "#000",
                    p: 0.1,
                    height: "40px !important",
                    position: "absolute",
                    right: 15,
                    top: "23%",
                    transform: "rotate(90deg)",
                  }}
                />
                <Divider
                  sx={{
                    bgcolor: "#000",
                    p: divider2Padding,
                    height: `${divider2Height} !important`,
                    position: "absolute",
                    right: -5,
                    top: `${
                      index % 2 == 1
                        ? `calc(23% - ${divider2Style})`
                        : "calc(23% + 19px)"
                    }`,
                  }}
                />
                <Divider
                  sx={{
                    bgcolor: "#000",
                    p: 0.1,
                    height: "40px !important",
                    position: "absolute",
                    transform: "rotate(90deg)",
                    right: -25,
                    top: divider3Style,
                    display: `${index % 2 == 1 && "none"}`,
                  }}
                />
              </>
            )}
          </Box>
        );
      })}
    </Grid>
  );
};

export default DummyRound;
